import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InjectQueryParam } from '@ddt-web/generic-utils';
import { SharedQueryParamKey } from '@ddt-web/url';
import { Observable } from 'rxjs';

@Injectable()
export class IretireInterceptorService implements HttpInterceptor {
	@InjectQueryParam(SharedQueryParamKey.PAS_AS_OF_DATE) private readonly pasAsOfDateOverride: string;

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const isIretireRequest = request.url.includes('iretire');
		if (!isIretireRequest) {
			return next.handle(request);
		}	
		if (request.url.includes('calculation')) {
			request = this.overrideAsOfDate(request);
		}
		return next.handle(request);
	}

	private overrideAsOfDate(request: HttpRequest<any>): HttpRequest<any> {
		if (this.pasAsOfDateOverride) {
			const params = request.params.append('asOfDate', this.pasAsOfDateOverride);
			const modifiedReq = request.clone({
				params: params
			});
			return modifiedReq;
		}
		return request;
	}
}
